import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useTrocaAutomaticaHorarioOutletContext } from '@/pages/TrocaAutomaticaHorario.context'
import { CreateTrocaAutomaticaTabelaSchema, trocaHorario } from '@/service/api'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'
import FormTrocaAutomatica from './forms/FormTrocaAutomatica'

export default function EditarTrocaAutomaticaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaAutomaticaHorarioOutletContext()
    const { mutateAsync, isLoading } =
        trocaHorario.trocaAutomatica.mutations.useUpdate({
            invalidateQuery: true,
        })

    const item = data?.find(it => it.id === Number(id))
    if (!item) return null

    function handleSubmit(values: any) {
        return mutateAsync(
            { ...values, id: Number(id) },
            {
                onSuccess: () => {
                    toast.success('Troca atualizada com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['update', 'TrocaAutomáticaDeHorário'])}
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={{ ...item, every: String(item.every) }}
            schema={CreateTrocaAutomaticaTabelaSchema}
        >
            <Dialog.Title action="Editar troca automática de horário">
                {item.Funcionario?.nome}
            </Dialog.Title>
            <Dialog.Content>
                <FormTrocaAutomatica editar />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
